<div class="notification-popup-block" (click)="navigateToUri($event)">
    <div class="notification-popup-block__profilepic">
        <img
            alt=""
            class="profilepic--round"
            src="{{ notification.insertedUser.profilePictureUri }}" />
    </div>
    <span
        class="notification-popup-block__content"
        [innerHTML]="notification.message"></span>
    <span class="spacer"></span>
    <mat-icon
        class="notification-popup-block__close"
        (click)="readNotification($event)"
        >close</mat-icon
    >
</div>
